import { InventoriesActionsTypes } from "../types/Inventories.reducer.types";

export function listRequest(filter, { isAdmin = false }) {
  return {
    type: InventoriesActionsTypes.LIST_REQUEST,
    payload: { filter, isAdmin }
  };
}
